import { Box } from '@mui/material';

interface LiveRegionProps {
  /** Message courant à annoncer aux lecteurs d'écran. */
  message: string;
}

/**
 * Région live ARIA (WCAG 4.1.3) : un conteneur visuellement caché mais lu par
 * les lecteurs d'écran. `role="status"` + `aria-live="polite"` : les changements
 * de contenu sont annoncés sans voler le focus, à la prochaine pause de la
 * synthèse vocale. `aria-atomic` force la relecture du message complet.
 *
 * Visuellement caché (pattern « sr-only ») : retiré du flux visuel mais reste
 * dans l'arbre d'accessibilité (donc PAS de `display: none` ni `visibility: hidden`,
 * qui le masqueraient aussi aux lecteurs d'écran).
 */
export default function LiveRegion({ message }: LiveRegionProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-atomic="true"
      sx={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      {message}
    </Box>
  );
}
